var _defs, _polygon, _polygon2, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEkProposal4Hexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-label": "Engin Kaya",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p4-fill",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dbeafe"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "60,6 110,34 110,86 60,114 10,86 10,34",
    fill: "url(#p4-fill)",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "60,6 110,34 110,86 60,114 10,86 10,34",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 2.5,
    opacity: 0.35
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 68,
    textAnchor: "middle",
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 34,
    fontWeight: 800,
    letterSpacing: -1.5,
    fill: "#0f172a"
  }, "ek")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 82 H82",
    stroke: "#00bdfe",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkProposal4Hexagon);
export default __webpack_public_path__ + "static/media/ek-proposal-4-hexagon.dedab1825b73815a465cbddf81aa766a.svg";
export { ForwardRef as ReactComponent };